import { makeObservable }        from 'mobx';
import { observable }            from 'mobx';
import { runInAction }           from 'mobx';
import { ClientRequestStatusId } from '@models/account/ClientRequestStatusModel';
import countClientRequests       from '@/tools/countClientRequests';

const FRESHNESS_MS = 2000;

class ClientRequestCounterStore {
	public submittedCount = 0;

	private _pending?: Promise<number>;
	private _fetchedAt = 0;

	public constructor() {
		makeObservable(this, { submittedCount: observable });
	}

	public refresh(force = false): Promise<number> {
		if (!force && this._pending) return this._pending;
		if (!force && Date.now() - this._fetchedAt < FRESHNESS_MS) return Promise.resolve(this.submittedCount);

		const previous = this._pending?.catch(() => undefined) ?? Promise.resolve();
		const current = previous.then(() => this._fetch());

		this._pending = current;
		current
			.finally(() => {
				if (this._pending === current) this._pending = undefined;
			})
			.catch(() => undefined);

		return current;
	}

	private async _fetch() {
		const count = await countClientRequests({ clientRequestStatus: ClientRequestStatusId.submitted });

		runInAction(() => this.submittedCount = count);
		this._fetchedAt = Date.now();

		return count;
	}
}

export default new ClientRequestCounterStore();
